import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../../services/client.service'; 
import { PetService } from '../../../services/pet.service'; 
import { PetModel } from '../../../models/pet.model';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'ngx-no-pet-page',
  templateUrl: './no-pet-page.component.html' 
})
export class NoPetPageComponent implements OnInit {

  constructor(
    public clientService: ClientService,
    public petService: PetService,
  ) {
        this.clientService.work_standalone_page = true
        this.clientService.work_pet_ribbon = false
        this.clientService.work_brief = false
   }

  ngOnInit(): void {
  }


  add() {
    this.petService.pet = new PetModel(0, 0, '', '', 0, '', '', '', '', '', 0, 0, '', '', '', '', '', 0, 0, 0, '', false, 0, '', '', '', '', 0,0,'',0,'', false);
    this.clientService.selected_client.client_name = this.clientService.client.first_name + ' ' + this.clientService.client.last_name
    this.petService.pet.client_no = Number(this.clientService.client.client_no); 
    this.petService.createNewPetOrigin = 'work'
    $("#modalAddPet").modal('toggle');
  }

  deleteClient() {
    Swal.fire({
      title: 'Delete this Client?',
      text: 'Confirm Deletion of '+ this.clientService.client.first_name + ' ' + this.clientService.client.last_name,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
          this.clientService.deleteClient(this.clientService.client.client_no).then(() => {})
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return false;
      }
    });
  }
}
